module.exports = __webpack_public_path__ + "img/dchLogoWhite.5c79df04.png";